module.exports = __webpack_public_path__ + "img/image-victor-glover.9015628a.png";